import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "UnitedHealthcare",
  shortName: "UnitedHealthcare",
  slug: "unitedhealthcare-insurance",
  seoTitle: "UnitedHealthcare TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have UnitedHealthcare insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your UHC plan in Coral Springs, FL.",
  seoKeywords:
    "UnitedHealthcare TMS coverage, UHC TMS therapy, UnitedHealthcare depression treatment Florida, UHC mental health benefits Coral Springs FL, UnitedHealthcare SAINT TMS",
  planType: "national health insurance provider (Optum behavioral health)",
  planRegion: "nationwide",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "UnitedHealthcare is one of the largest health insurance providers in the United States, offering commercial, employer-sponsored, Medicare Advantage, and Medicaid plans. UnitedHealthcare plans typically include behavioral health benefits — often administered through Optum Behavioral Health — that may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because UHC offers many plan types and network arrangements, coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan and network.",
  officialResourceUrl: "https://www.uhc.com/",
  officialResourceLabel: "UnitedHealthcare official website",
};

export const UnitedHealthcareInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default UnitedHealthcareInsurance;
